import moment from 'moment';
import React, { Component } from 'react';
import { Form, Input, Label } from 'reactstrap';

class DateSelector extends Component {
  constructor(props) {
    super(props);
    const date = moment(this.props.date);
    this.state = {
      properties: {
        dateOfMonth: date.date(),
        month: date.month(),
        year: date.year(),
      },
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillReceiveProps(nextProps) {
    const date = moment(nextProps.date);
    this.setState({
      properties: {
        dateOfMonth: date.date(),
        month: date.month(),
        year: date.year(),
      },
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  get daysInMonth() {
    const daysInMonth = moment(this.props.date).daysInMonth();
    const zeroIndexed = Array.from(Array(daysInMonth).keys());
    return zeroIndexed.map(index => index + 1);
  }

  handleChange(name, value) {
    this.setState(
      state => ({ properties: { ...state.properties, [name]: parseInt(value, 10) } }),
      () => {
        const date = moment().year(this.state.properties.year)
          .month(this.state.properties.month)
          .date(this.state.properties.dateOfMonth);
        this.props.onChange(date.toISOString());
      },
    );
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="form-inline" name="dateSelector">
        <Label className="sr-only" for="month" />
        <Input
          className="form-control"
          name="month"
          onChange={event => this.handleChange(event.target.name, parseInt(event.target.value, 10))}
          type="select"
          value={this.state.properties.month}
        >
          {moment.months().map((month, index) => (
            <option
              key={index.toString()}
              value={index}
            >
              {month}
            </option>
          ))}
        </Input>
        <Label className="sr-only" for="dateOfMonth" />
        <Input
          className="form-control"
          name="dateOfMonth"
          onChange={event => this.handleChange(event.target.name, parseInt(event.target.value, 10))}
          type="select"
          value={this.state.properties.dateOfMonth}
        >
          {this.daysInMonth.map(day => (
            <option
              key={day.toString()}
              value={day}
            >
              {(day).toString()}
            </option>
          ))}
        </Input>
        <Label className="sr-only" for="year" />
        <Input
          className="form-control"
          name="year"
          onChange={event => this.handleChange(event.target.name, parseInt(event.target.value, 10))}
          type="select"
          value={this.state.properties.year}
        >
          <option value={2017}>2017</option>
          <option value={2018}>2018</option>
          <option value={2019}>2019</option>
        </Input>
      </div>
    );
  }
}

export default DateSelector;
